
































import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'
import { lookup } from 'mime-types'
import { saveAs } from 'file-saver'
import { EventBus } from '@/utils/event-bus'
import pdfjsLib from 'pdfjs-dist/webpack'
import 'pdfjs-dist/build/pdf.worker.entry'
import { GvdUpdate } from '@/store/modules/gvd'
import { SlideDeckUpdate } from '@/store/modules/slideDeck'

@Component
export default class ChangeLogPreviewModal extends Vue {
  @Prop({ default: () => [], required: false })
  readonly previewLog!: (GvdUpdate | SlideDeckUpdate)[];

  fileSrc: string = '';
  resourceMimeType: string = '';
  mounted () {
    this.$root.$on('bv::modal::hide', (bvEvent: any, modalId: any) => {
      this.fileSrc = ''
    })
  }

  async loadContent () {
    const item = this.previewLog[0]
    let url = ''
    if ((item as GvdUpdate)?.gvdKey) {
      // get gvd
      url = `gvds/download-log/${(item as GvdUpdate)?.gvdKey}`
    } else if ((item as SlideDeckUpdate)?.slideDeckKey) {
      // get slide deck
      url = `slide-decks/download-log/${(item as SlideDeckUpdate)?.slideDeckKey}`
    }

    EventBus.$emit('show-loader')
    await axios
      .get(url, {
        withCredentials: true,
        responseType: 'blob'
      })
      .then(response => {
        if (response.data === undefined) {
          this.$bvModal.hide('changelog-preview-modal')
        } else {
          const blob = new Blob([response.data], {
            type: 'application/pdf'
          })
          const objectUrl = URL.createObjectURL(blob)
          this.resourceMimeType = 'application/pdf'
          this.fileSrc = objectUrl

          if (this.resourceMimeType === 'application/pdf') {
            this.renderPdf(objectUrl)
          }
        }
      }).catch(() => {
        EventBus.$emit('hide-loader')
      }).finally(() => {
        EventBus.$emit('hide-loader')
      })
  }

  async renderPdf (url: string) {
    try {
      const loadingTask = pdfjsLib.getDocument(url)
      const pdf = await loadingTask.promise
      const container = this.$refs.pdfContainer as HTMLElement

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum)
        const viewport = page.getViewport({ scale: 1.5 })
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        if (context) {
          canvas.height = viewport.height
          canvas.width = viewport.width

          const renderContext = {
            canvasContext: context,
            viewport: viewport
          }
          await page.render(renderContext).promise
          container.appendChild(canvas)
        }
      }
    } catch (error) {
      console.error('Error rendering PDF:', error)
    }
  }

  downloadFile () {
    saveAs(this.fileSrc, 'change-log.pdf')
  }

  preventContextMenu (event: MouseEvent) {
    event.preventDefault()
  }
}
